export default function forceUniqueSizeToSizeFilters(uiState, mainIndex) {
  const allSizesFilters = uiState[mainIndex]?.refinementList?.sizes;
  const availableSizesFilters = uiState[mainIndex]?.refinementList?.available_sizes;
  const availableSizesForC1Filters = uiState[mainIndex]?.refinementList?.available_sizes_for_c1;
  if (
    !allSizesFilters?.length &&
    !availableSizesFilters?.length &&
    !availableSizesForC1Filters?.length
  )
    return uiState;

  const newUiState = { ...uiState };

  if (allSizesFilters?.length) {
    if (allSizesFilters.length === 1 && allSizesFilters[0] === "TU") {
      newUiState[mainIndex].refinementList.sizes = [];
    }

    if (!allSizesFilters.includes("TU")) {
      newUiState[mainIndex].refinementList.sizes.push("TU");
    }
  }

  if (availableSizesFilters?.length) {
    if (availableSizesFilters.length === 1 && availableSizesFilters[0] === "TU") {
      newUiState[mainIndex].refinementList.available_sizes = [];
    }

    if (!availableSizesFilters.includes("TU")) {
      newUiState[mainIndex].refinementList.available_sizes.push("TU");
    }
  }

  if (availableSizesForC1Filters?.length) {
    if (availableSizesForC1Filters.length === 1 && availableSizesForC1Filters[0] === "TU") {
      newUiState[mainIndex].refinementList.available_sizes_for_c1 = [];
    }

    if (!availableSizesForC1Filters.includes("TU")) {
      newUiState[mainIndex].refinementList.available_sizes_for_c1.push("TU");
    }
  }

  return newUiState;
}
